import { call, put } from 'redux-saga/effects';
import { retriable } from '../retriable';
import { ERROR_MESSAGE, SUCCESS_MESSAGE } from '../../redux/modules/message/message-actions';
import { HIDE_SPINNER, SHOW_SPINNER } from '../../redux/modules/spinner/spinner';
import {
    didApiCallFailDueToUnauthorizedUser,
    didApiCallFailDueToVersionMismatch,
    getErrorMessage,
    isValidFunction,
} from '../../constants/CommonUtil';
import { MISMATCH_IN_VERSION, SESSION_TIMEOUT } from '../../redux/modules/login/login-actions';
import messages from '../../constants/messages';
import {
    CREATE_ACCOUNT_INVOICE_SUCCESS,
    FETCH_ACCOUNT_INVOICE_FAILURE,
    FETCH_ACCOUNT_INVOICE_SUCCESS,
} from '../../redux/modules/accountInvoice/accountInvoice-actions';
import { ACCOUNT_INVOICE_OPERATION } from '../../mapper/AccountInvoiceMapper';
import { getStringFromObject } from '../../constants/lodashUtils';

export function* createAccountInvoiceWorker(action) {
    try {
        const config = {
            headers: { 'Content-Type': 'application/json' },
        };
        yield put({ type: SHOW_SPINNER, state: { canShow: true } });
        const materialReceiveUuid = getStringFromObject('accountInvoice.materialReceiveUuid', action);
        const api = materialReceiveUuid ? `${action.api}${materialReceiveUuid}` : action.api;
        const response = yield call(retriable().post, api, action.accountInvoice, config);
        yield put({
            type: CREATE_ACCOUNT_INVOICE_SUCCESS,
            data: response.data,
        });
        if (isValidFunction(action.successCallback)) {
            action.successCallback(response.data);
        }
        if (action.accountInvoice.state === ACCOUNT_INVOICE_OPERATION.DRAFT) {
            const msg = action.accountInvoice.uuid ? messages.ACCOUNT_INVOICE.UPDATE.SUCCESS
                : messages.ACCOUNT_INVOICE.CREATE.SUCCESS;
            yield put({ type: SUCCESS_MESSAGE, message: msg });
        } else {
            yield put({ type: SUCCESS_MESSAGE, message: messages.ACCOUNT_INVOICE.CONFIRM.SUCCESS });
        }
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    } catch (e) {
        // do error action
        console.log('asdauda0-sd', action);
        if (isValidFunction(action.failureCallBack)) {
            action.failureCallBack();
        }
        if (didApiCallFailDueToUnauthorizedUser(e)) {
            yield put({ type: SESSION_TIMEOUT, actionToDispatchAfterLogin: action });
        } else if (didApiCallFailDueToVersionMismatch(e)) {
            yield put({ type: MISMATCH_IN_VERSION });
        } else {
            let msg = '';
            if (action.accountInvoice.operation === ACCOUNT_INVOICE_OPERATION.DRAFT) {
                msg = action.accountInvoice.uuid ? messages.ACCOUNT_INVOICE.UPDATE.FAILED :
                    messages.ACCOUNT_INVOICE.CREATE.FAILED;
            } else {
                msg = messages.ACCOUNT_INVOICE.CONFIRM.FAILED;
            }
            yield put({ type: ERROR_MESSAGE, message: `${msg}: ${getErrorMessage(e)}` });
        }
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    }
}

export function* fetchAccountInvoiceWorker(action) {
    try {
        yield put({ type: SHOW_SPINNER, state: { canShow: true } });
        const response = yield call(retriable().get, action.api);
        yield put({
            type: FETCH_ACCOUNT_INVOICE_SUCCESS,
            data: response.data,
        });
        if (isValidFunction(action.successCallback)) {
            action.successCallback(response.data);
        }
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    } catch (e) {
        // do error action
        if (isValidFunction(action.failureCallBack)) {
            action.failureCallBack();
        }
        if (didApiCallFailDueToUnauthorizedUser(e)) {
            yield put({ type: SESSION_TIMEOUT, actionToDispatchAfterLogin: action });
        } else if (didApiCallFailDueToVersionMismatch(e)) {
            yield put({ type: MISMATCH_IN_VERSION });
        } else {
            yield put({
                type: ERROR_MESSAGE,
                message: `${messages.ACCOUNT_INVOICE.FETCH_FAILED}: ${getErrorMessage(e)}`,
            });
        }
        yield put({ type: FETCH_ACCOUNT_INVOICE_FAILURE });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    }
}
